import { Phone, Truck, Headset, Shield, MapPin } from "lucide-react";
import { SITE } from "@/lib/siteConfig";

const TEAM_PHOTO =
  "https://customer-assets.emergentagent.com/job_emergency-lock-3/artifacts/2q13llie_IMG_2183.jpg";
const VAN_PHOTO =
  "https://customer-assets.emergentagent.com/job_emergency-lock-3/artifacts/zld5cqo3_photo.png";

export default function TeamSection() {
  return (
    <section data-testid="team-section" className="bg-white py-20 sm:py-28 reveal">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="text-xs tracking-[0.25em] uppercase font-bold text-red-600 mb-4">
            — Notre équipe
          </div>
          <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] text-[#0A0A0A]">
            <span className="text-red-600">SOS Serrurier Express</span><br />
            une équipe à votre service.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Standardistes humains, techniciens qualifiés, camions équipés. Nos équipes sont mobilisées 24h/24 et 7j/7.
          </p>
        </div>

        {/* Two image cards with overlay */}
        <div className="grid md:grid-cols-2 gap-5">
          {/* Team / standardistes */}
          <div className="relative group overflow-hidden border border-black/10 aspect-[4/3]">
            <img
              src={TEAM_PHOTO}
              alt="Équipe standardistes SOS Serrurier Express"
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-[800ms] group-hover:scale-105"
              style={{ objectPosition: "center 22%" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
            <div className="absolute top-5 left-5">
              <div className="inline-flex items-center gap-2 bg-red-600 text-white px-3 py-1.5 text-[10px] uppercase tracking-[0.2em] font-bold">
                <Headset className="w-3 h-3" strokeWidth={3} />
                Standardistes 24/7
              </div>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-6 text-white">
              <div className="font-display font-black text-2xl sm:text-3xl uppercase tracking-tight">
                Une voix humaine.<br />Pas de robot.
              </div>
              <div className="mt-3 text-sm text-slate-200">
                Notre équipe répond en moins d'une sonnerie, jour et nuit.
                Diagnostic au téléphone, devis immédiat, déclenchement instantané.
              </div>
            </div>
          </div>

          {/* Van / camion d'intervention */}
          <div className="relative group overflow-hidden border border-black/10 aspect-[4/3] bg-[#0A0A0A]">
            <img
              src={VAN_PHOTO}
              alt="Camion d'intervention SOS Serrurier Express"
              loading="lazy"
              className="w-full h-full object-contain p-4 transition-transform duration-[800ms] group-hover:scale-105"
            />
            <div className="absolute top-5 left-5">
              <div className="inline-flex items-center gap-2 bg-red-600 text-white px-3 py-1.5 text-[10px] uppercase tracking-[0.2em] font-bold">
                <Truck className="w-3 h-3" strokeWidth={3} />
                Flotte d'intervention
              </div>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-6 text-white bg-gradient-to-t from-black/95 via-black/60 to-transparent">
              <div className="font-display font-black text-2xl sm:text-3xl uppercase tracking-tight">
                Camion équipé.<br />Stock pro embarqué.
              </div>
              <div className="mt-3 text-sm text-slate-200">
                Chaque véhicule transporte 200+ références : serrures, cylindres, blindages,
                outils de crochetage haute précision.
              </div>
            </div>
          </div>
        </div>

        {/* Trust strip */}
        <div className="mt-10 bg-[#0A0A0A] text-white p-6 sm:p-8 grid sm:grid-cols-3 gap-6 sm:gap-8 items-center">
          <div className="sm:col-span-2 flex items-center gap-4">
            <div className="w-14 h-14 bg-red-600 flex items-center justify-center font-display font-black text-xl flex-shrink-0">
              SOS
            </div>
            <div>
              <div className="font-display font-black text-2xl uppercase tracking-tight">
                SOS Serrurier Express
              </div>
              <div className="text-sm text-slate-300 mt-1 flex items-center gap-2">
                <Shield className="w-3.5 h-3.5 text-red-500" />
                Société française · SIRET vérifié · Assurance RC Pro
              </div>
            </div>
          </div>
          <a
            href={SITE.phoneHref}
            data-testid="team-call"
            className="inline-flex items-center justify-center gap-3 bg-red-600 hover:bg-red-500 text-white px-6 py-4 font-display font-bold uppercase tracking-tight transition"
          >
            <Phone className="w-5 h-5" strokeWidth={2.5} />
            {SITE.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
